import {Injectable} from "@angular/core";
import {Location as LocationService} from "@angular/common";
import {Router, CanActivate,
        ActivatedRouteSnapshot,
        RouterStateSnapshot, CanActivateChild} from "@angular/router";
import {GlobalService} from "../GlobalService";
import {UserService} from "../Authorization/UserService";
import {AuthorizationService} from "../Authorization/AuthorizationService";
import {SessionStorageService} from "../Storage/SessionStorageService";

@Injectable()
export class RouteMonitor implements CanActivate, CanActivateChild {

    private redirectUrl: string;

    constructor(
        private globalService: GlobalService,
        private userService: UserService,
        private locationService: LocationService,
        private router: Router,
        private authorizationService: AuthorizationService,
        private sessionStorage: SessionStorageService) {
    }

    get user(): NPS.Common.IUser {
        return this.userService.user;
    }
    
    get sessionEmptyOrExpired(): boolean {
        return !this.user || this.userService.isAccessTokenExpired(this.user);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        const isLoggedIn: boolean = this.checkLogin(url);

        const ssoReturnUrl = this.sessionStorage.get<string>("ssoReturnUrl");
        if (isLoggedIn && ssoReturnUrl) {
            this.sessionStorage.remove("ssoReturnUrl");
            this.router.navigateByUrl(ssoReturnUrl);
        }
        return isLoggedIn;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(childRoute, state);
    }

    checkLogin(url: string): boolean {
        this.authorizationService.checkRenewalTimer();
        if (this.sessionEmptyOrExpired) {
            this.authorizationService.trySilentLogin()
                .then((token:string) => {
                    this.router.navigateByUrl(url);
                }, (error:string) => {
                    this.sessionStorage.set("ssoReturnUrl", url);
                    this.authorizationService.requestSSOLogin();
                });

            return false;
        } else {
            return true;
        }
    }

    oauthUrlCheck(newRoute: string) {
        // Change format of oauthcallback url to url with query params
        // so that @angular/router can process
        if (newRoute.indexOf("oauthcallback/") > -1
        ) {
            var newPath = this.locationService.path().replace("oauthcallback/", "oauthcallback?");
            this.router.navigateByUrl(newPath);
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Route/RouteMonitor.ts